/* ═══ PRODUCT.JS — StreetMode ═══ */

// Thumbnail click → change main image
function changeImage(thumb, src) {
  document.querySelectorAll('.thumb').forEach(function(t) { t.classList.remove('active'); });
  thumb.classList.add('active');
  document.getElementById('main-img').src = src;
}

// Mobile gallery dot sync
(function(){
  var track = document.getElementById('mob-gallery-track');
  if (!track) return;
  var dots = document.querySelectorAll('.mob-dot');
  if (!dots.length) return;
  var slides = track.querySelectorAll('.mob-gallery-slide');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var idx = Array.from(slides).indexOf(entry.target);
        dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
      }
    });
  }, { root: track, threshold: 0.6 });
  slides.forEach(function(s) { observer.observe(s); });
})();

// Size selector
function selectSize(el) {
  document.querySelectorAll('.pi-size').forEach(function(s) { s.classList.remove('active'); });
  el.classList.add('active');
  var label = document.getElementById('selected-size');
  if (label) label.textContent = el.textContent.trim();

  // Update variant data
  var size = el.getAttribute('data-value');
  if (typeof productVariants !== 'undefined' && typeof sizeOptionIndex !== 'undefined' && sizeOptionIndex >= 0) {
    var v = productVariants.find(function(vr) { return vr.opt[sizeOptionIndex] === size; });
    if (v) {
      var idInput = document.getElementById('variant-id');
      if (idInput) idInput.value = v.id;

      var skuEl = document.getElementById('pi-sku');
      if (skuEl) skuEl.textContent = v.sku ? 'SKU: ' + v.sku : '';

      var addBtn = document.querySelector('.pi-add-cart');
      var stockEl = document.getElementById('pi-stock-msg');
      if (v.qty > 0) {
        // In stock
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Sepete Ekle'; }
        if (stockEl) { stockEl.innerHTML = 'Stok var · gönderime hazır'; stockEl.style.color = '#2d7a3a'; }
      } else if (v.policy === 'continue') {
        // Pre-order
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Ön Sipariş Ver'; }
        if (stockEl) { stockEl.innerHTML = '⏳ Ön Sipariş · Kargonun size ulaşması 2-3 haftayı bulabilir'; stockEl.style.color = '#d4870e'; }
      } else {
        // Sold out
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Tükendi'; }
        if (stockEl) { stockEl.innerHTML = 'Tükendi'; stockEl.style.color = '#c00'; }
      }
    }
  }
}

// Quantity
function changeQty(d) {
  var inp = document.getElementById('qty-input');
  var v = parseInt(inp.value) + d;
  if (v < 1) v = 1;
  if (v > 10) v = 10;
  inp.value = v;
}

// Accordion
function toggleAcc(header) {
  var body = header.nextElementSibling;
  var icon = header.querySelector('span');
  var isOpen = body.style.display === 'block' || body.classList.contains('open');
  if(isOpen) {
    body.style.display = 'none';
    body.classList.remove('open');
    icon.textContent = '+';
  } else {
    body.style.display = 'block';
    body.classList.add('open');
    icon.textContent = '−';
  }
}

// Lightbox
var lbScale = 1, lbX = 0, lbY = 0, lbDragging = false, lbStartX, lbStartY;
var lbMoved = false, lbDownX = 0, lbDownY = 0;

function openLightbox(src) {
  initLbImages();
  lbIdx = lbImages.indexOf(src);
  if (lbIdx < 0) lbIdx = 0;
  var lb = document.getElementById('lb-overlay');
  document.getElementById('lb-img').src = src;
  lbScale = 1; lbX = 0; lbY = 0;
  updateLbTransform();
  lb.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeLightbox() {
  document.getElementById('lb-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

function updateLbTransform() {
  document.getElementById('lb-img').style.transform = 'scale(' + lbScale + ') translate(' + lbX + 'px,' + lbY + 'px)';
}

// Lightbox navigation
var lbImages = [];
var lbIdx = 0;
function initLbImages() {
  lbImages = [];
  document.querySelectorAll('.thumb img').forEach(function(img) { 
    lbImages.push(img.src.replace(/width=\d+/, 'width=1200')); 
  });
}
function lbNav(dir) {
  initLbImages();
  lbIdx += dir;
  if (lbIdx < 0) lbIdx = lbImages.length - 1;
  if (lbIdx >= lbImages.length) lbIdx = 0;
  lbScale = 1; lbX = 0; lbY = 0;
  document.getElementById('lb-img').src = lbImages[lbIdx];
  updateLbTransform();
}

// Lightbox events
var lbWrap = document.getElementById('lb-wrap');
if (lbWrap) {
  lbWrap.addEventListener('wheel', function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (lbScale > 1) {
      var maxPan = (lbScale - 1) * 250;
      lbY -= e.deltaY * 0.08;
      lbX -= e.deltaX * 0.08;
      lbX = Math.max(-maxPan, Math.min(maxPan, lbX));
      lbY = Math.max(-maxPan, Math.min(maxPan, lbY));
    }
    updateLbTransform();
  }, { passive: false });

  lbWrap.addEventListener('mousedown', function(e) {
    lbMoved = false;
    lbDownX = e.clientX; lbDownY = e.clientY;
    if (lbScale > 1) {
      lbDragging = true; lbStartX = e.clientX - lbX; lbStartY = e.clientY - lbY;
      this.classList.add('dragging');
    }
  });

  lbWrap.addEventListener('mouseup', function(e) {
    var dist = Math.abs(e.clientX - lbDownX) + Math.abs(e.clientY - lbDownY);
    if (dist < 6) {
      if (lbScale > 1) { lbScale = 1; lbX = 0; lbY = 0; }
      else { lbScale = 2.5; }
      updateLbTransform();
    }
  });
}

document.addEventListener('mousemove', function(e) {
  if (!lbDragging) return;
  var maxPan = (lbScale - 1) * 250;
  lbX = Math.max(-maxPan, Math.min(maxPan, (e.clientX - lbStartX) * 0.5));
  lbY = Math.max(-maxPan, Math.min(maxPan, (e.clientY - lbStartY) * 0.5));
  updateLbTransform();
});

document.addEventListener('mouseup', function() {
  lbDragging = false;
  var w = document.getElementById('lb-wrap');
  if (w) w.classList.remove('dragging');
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeLightbox();
  if (e.key === 'ArrowLeft') lbNav(-1);
  if (e.key === 'ArrowRight') lbNav(1);
});

// Size chart modal
var sizeChartBtn = document.getElementById('size-chart-btn');
if (sizeChartBtn) {
  sizeChartBtn.addEventListener('click', function() {
    document.getElementById('sc-overlay').classList.add('open');
  });
}

// Recommendations scroll
function recScroll(dir) {
  var grid = document.getElementById('rec-grid');
  if (!grid) return;
  var card = grid.querySelector('.rec-card');
  if (!card) return;
  var scrollAmt = (card.offsetWidth + 14) * dir;
  grid.scrollBy({ left: scrollAmt, behavior: 'smooth' });
}
